import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GameContainer from "../components/games/game_container/GameContainer";
import ShowContainer from "../components/mui/ShowContainer";
import { API_CASINO } from "../api/casino";
import useNavigateWithSearch from "../hooks/useNavigateWitchSearch";
import { errorToast } from "../components/mui/Toaster";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../store/index.ts";

export default function Game() {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigateWithSearch();
  const [currentGame, setCurrentGame] = useState(null);
  const currency = useAppSelector((state) => state.user.currency);

  useEffect(() => {
    if (!id) return;

    API_CASINO.list
      .games({ gameId: id, currency })
      .then((e) => {
        const list = e.data.list;
        if (!list.length) {
          navigate("/");
          errorToast(t("A game with this ID was not found."));
          return;
        }
        const currentGame = list.find((el) => el.game_id == id);
        setCurrentGame(currentGame);
      })
      .catch(console.error);
  }, [id]);

  return (
    <ShowContainer condition={currentGame}>
      <GameContainer currentGame={currentGame} isBonus={false} gameId={currentGame?.game_id} />
    </ShowContainer>
  );
}
